module.exports = __webpack_public_path__ + "static/media/Corn5VT.fec44811.png";